import {
  ChartMessageItem,
  MessageAuditStatus,
  MessageMaskType,
  MessageType,
  strToType,
} from "../../constants/types";
import { Message, MessageSchema } from "../../realm/schema";
import { User } from "../../../imsdk/db/t_user";
import React, { useEffect, useRef, useState } from "react";
import { showSystemMsg } from "./chat-helper";
import { useAppNavigation } from "../navigation";
import {
  buildSignalTopicId,
  getAvatarByItem,
  getDisplayName,
  getGroupTag,
  isGroupTopic,
  sendFail,
  sendSuc,
} from "../../utils/utils";
import {
  GestureResponderEvent,
  Platform,
  Pressable,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { getEncrypt, getMsgTranslate, getUid } from "../../store/token";
import * as ImSdk from "../../../imsdk/api";
import {
  black10,
  black30,
  color_333333,
  color_666666,
  color_999999,
  color_9F9E9E,
  color_main,
  ColorLine,
  white,
} from "../../assets/style/colors";
import { postJson, ResponseContext } from "../../net/http";
import { LeftView, SystemTopic } from "./CListItem";
import { ReadCountStatus } from "./components/ChatItemsRender";
import { ContentRender } from "./ContentRender";
import { Group } from "../../../imsdk/db/t_group";
import { ChatPropsEvent } from "./ChatInput";
import {
  Str_AddSucc,
  Str_Admin,
  Str_DelFail,
  Str_Group_owner,
  Str_ReEdit,
  Str_WithdrawAMsg,
  Str_You,
} from "../../language/string_res";
import { showToast } from "../../components/Toast";
import { hideLoading, showLoading } from "../../components/Loading";
import { getCurLanguageStr, extractUrls } from "../../utils/CommonUtils";
import { PickerResult } from "../../utils/PicOrCameraManager";
import { VoiceContentIntent } from "./components/VoiceContentRender";
import { ChatPopMenu } from "./ChatPopMenu";
import { GroupMember } from "../../../imsdk/db/t_group_member";
import { QuoteContentRender } from "./components/QuoteRender";
import { Meta } from "../../../imsdk/db/t_msg";
import { SendMsgRequestData } from "../../net/request";
import { t } from "i18next";
import { CryptEngine } from "../../utils/CryptEngine";
import { upsetMsg } from "../../store/ChatStore";
import { sendMsg } from "../../net/service";
import globalEventBus from "../../utils/EventBus";
import time from "../../../imsdk/time";
import { fixRemoteUrl } from "../../../imsdk/api";

interface chatViewItemRender {
  talkSelectStatus: boolean;
  uid: number;
  item: ChartMessageItem;
  group?: Group;
  isAdmin?: boolean;
  users?: (User | GroupMember)[];
  handleChangeMask(item: MessageSchema, mask: MessageMaskType): void;

  handleRecall(val: string): void;

  toNavigation?: () => void;

  handleQuote(item: MessageSchema): void;

  handleDel(item: MessageSchema): void;

  handleQuoteLocal(meta: Meta): void;

  onLongPressUserHead?(user: User): void;

  onClick?(item: MessageSchema): void; // 单击事件

  submitMsg: (e: ChatPropsEvent) => void;

  submitMediaMsg: (result: PickerResult[]) => void;
}

function timestampToTime(timestamp: number): string {
  const date = new Date(timestamp);
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  return `${hours}:${minutes}`;
}

/**
 * 修改消息删除
 * @param item
 * @param mask
 * @param onSuccess
 */
function postDelete(
  item: MessageSchema,
  onSuccess: (r: ResponseContext<any, any>) => void
) {
  postJson("/v1/sdk/msg/local/delete", {
    body: {
      mids: [item.mid],
      tid: item.tid,
    },
  }).then(onSuccess);
}

/**
 * 修改消息删除/撤回状态，考虑后续需要实现动画，放在viewItem中操作这个改变
 * @param item
 * @param mask
 * @param onSuccess
 */
function postChangeMask(
  item: MessageSchema,
  mask: MessageMaskType,
  onSuccess: (r: ResponseContext<any, any>) => void
) {
  postJson("/v1/sdk/msg/mask", {
    body: {
      mid: item.mid,
      mask,
    },
  }).then(onSuccess);
  // .catch ((err) => {
  //     // console.warn(err);
  // });
}

const ChatViewItemRender = (props: chatViewItemRender) => {
  // const [mask, updateMask] = useState(props.item.mask || 0);
  const navigation = useAppNavigation();
  const [systemTip, setSystemTip] = useState(props.item.meta?.systemTip || "");
  const isSignal = props.item.tid ? props.item.tid.startsWith("s_") : false;

  const chatItemRef = useRef<any>(null);
  const [showPopover, setShowPopover] = useState(false);
  const [popoverPosition, setPopoverPosition] = useState({ x: 0, y: 0 });
  const [tag, setTag] = useState(0);
  const [translate, setTranslate] = useState("");
  const voiceRef = useRef<VoiceContentIntent>(null);
  const { isBold, color } = JSON.parse(
    props.group?.group_admin_special || "{}"
  );

  useEffect(() => {
    const t = getGroupTag(props.item.sender, props.group);
    setTag(t);
    if (props.item.type === MessageType.SYSTEM) {
      showSystemMsg(JSON.parse(props.item.content), props.users).then((val) => {
        // 使用函数式更新，避免依赖 systemTip
        setSystemTip((prevTip: any) => {
          if (val !== prevTip) {
            ImSdk.getInstance().updateMsgMeta(props.item.mid, {
              systemTip: val,
            });
            return val;
          }
          return prevTip;
        });
      });
    }
  }, [
    props.item.sender,
    props.item.type,
    props.item.content,
    props.item.mid,
    props.group,
    props.users,
  ]);

  const isSelfSender = props.item.sender === props.uid;

  const flexStyle = isSelfSender
    ? chatViewStyles.msgItemRight
    : chatViewStyles.msgItemLeft;

  const msgStyle = isSelfSender
    ? chatViewStyles.sendedContent
    : chatViewStyles.receivedContent;

  const nameStyle = isSelfSender
    ? chatViewStyles.userNameRight
    : chatViewStyles.userNameLeft;

  // 添加依赖数组，避免每次渲染都执行
  useEffect(() => {
    const item = props.item;
    if (
      item.type === MessageType.TEXT &&
      getMsgTranslate() === 1 &&
      item.mid &&
      item.meta?.hasTranslate === "1"
    ) {
      ImSdk.getInstance()
        .QryTranslateLocal(props.item.mid)
        .then((r) => {
          if (r.data) {
            setTranslate(r.data);
          }
        });
    }
  }, [props.item.mid, props.item.type, props.item.meta?.hasTranslate]);

  function toNavigation() {
    props.toNavigation && props.toNavigation();
  }

  function onMenuClick(value: string) {
    switch (value) {
      case "Quote":
        props.handleQuote(props.item);
        break;
      case "Forward":
        navigation.navigate("ForwardChat", { msg: props.item });
        break;
      case "Delete":
        handleDelete();
        break;
      case "Withdraw":
        handleRecall();
        break;
      case "Multi":
        toNavigation();
        break;
      case "Collect":
        handleCollect();
        break;
      case "AddEmoticon":
        handleAddEmoticon();
        break;
      case "Translate":
        handleTranslate();
        break;
      case "CancelTranslate":
        handleCancelTranslate();
        break;
      case "Speaker":
      case "Receiver":
        // PlayerManager.changePlayOut(!PlayerManager.isReceiver);
        // voiceRef?.current?.play(value);
        break;
    }
  }

  // 翻译
  function handleTranslate() {
    const to = getCurLanguageStr();
    const mid = props.item.mid;
    const content = props.item.content;
    const meta = props.item.meta;

    ImSdk.getInstance()
      .QryTranslate(mid, content, to, meta)
      .then((r) => {
        if (r.data) {
          setTranslate(r.data);
        }
      });
  }

  function handleCancelTranslate() {
    ImSdk.getInstance()
      .CancelTranslateLocal(props.item.mid, props.item.meta)
      .then((r) => {
        setTranslate("");
      });
  }

  // 添加表情
  function handleAddEmoticon() {
    showLoading();

    // 获取图片 URL
    let imageUrl = fixRemoteUrl(props.item.content);

    // 检查 URL 是否已经包含 width 和 height 参数
    const hasWidthParam =
      imageUrl.includes("width=") || imageUrl.includes("&width=");
    const hasHeightParam =
      imageUrl.includes("height=") || imageUrl.includes("&height=");

    // 如果 URL 中没有尺寸参数，且 meta 中有尺寸信息，则拼接尺寸参数
    if (!hasWidthParam || !hasHeightParam) {
      const width = props.item.meta?.width;
      const height = props.item.meta?.height;

      if (width && height) {
        // 检查 URL 是否已有查询参数
        const hasQuery = imageUrl.includes("?");

        // 拼接尺寸参数
        if (!hasWidthParam) {
          const separator = hasQuery ? "&" : "?";
          imageUrl += `${separator}width=${width}`;
        }
        if (!hasHeightParam) {
          // 如果已经拼接了 width 或者 URL 中已有查询参数，使用 &，否则使用 ?
          const separator = imageUrl.includes("?") ? "&" : "?";
          imageUrl += `${separator}height=${height}`;
        }
      }
    }

    ImSdk.getInstance()
      .AddEmoticon(props.item.content)
      .then((r) => {
        let msg = "";
        if (r.emoticon) {
          msg = Str_AddSucc;
        } else {
          msg = r.error;
        }
        showToast(msg);
        hideLoading();
      });
  }

  function handleCollect() {
    const currentUid = ImSdk.getInstance().CurrentUid();
    const toTopidId = buildSignalTopicId(SystemTopic.Collect, currentUid);
    let encrypt = getEncrypt();
    const cid = Date.now();
    /* const msg: ChartMessageItem = {
      tid: toTopidId,
      cid: cid,
      type: strToType(props.item.type),
      content: props.item.content,
      atUids: props.item.atUids,
      meta: (props.item.meta || {}) as any,
      mid: "",
      encrypt: encrypt,
      sender: currentUid,
      send_statue: "0",
      user: props.item.user,
      stime: time.now().getTime(),
    }; */
    let content = props.item.content;

    if (encrypt === 1) {
      content = CryptEngine.encode(encrypt, content, cid);
    }

    const item: SendMsgRequestData = {
      toTopidId: toTopidId,
      type: props.item.type.toString(),
      content: content,
      cid: cid.toString(),
      encrypt: encrypt,
      meta: props.item.meta,
    };

    /*  if (msg.tid === props.item.tid) {
      globalEventBus.emit("SEND_MSG", msg);
    } */

    // upsetMsg(msg).then();
    sendMsg(item).then((res) => {
      if (res.code !== 0) {
        // sendFail(msg, props.item.tid, res.msg);
        showToast("收藏失败");
      } else {
        // sendSuc(msg);
        showToast("收藏成功");
      }
    });
    // .catch((err) => {
    //   sendFail(msg, err.msg);
    // });
  }

  function handleDelete() {
    function del() {
      const tid = props.item.tid;
      const cid = props.item.cid;
      const mid = props.item.mid;
      const sender = props.item.sender;

      ImSdk.getInstance()
        .DelMsgByCid(tid, cid, mid, sender)
        .then((r) => { });
      props.handleDel(props.item);
      ImSdk.getInstance().emit("msg_del", { msg_del: { tid: tid } });
    }

    if (props.item.send_statue === "0" || props.item.send_statue === "1") {
      del();
    } else {
      setTimeout(() => {
        postDelete(props.item, (r) => {
          if (r.code === 0) {
            del();
          }
        });
      }, 400);
    }
  }

  function handleRecall() {
    const mask = MessageMaskType.RECALL;
    setTimeout(() => {
      postChangeMask(props.item, mask, (r) => {
        // 需要通知一下父组件，删除消息之后会有位置变更的问题
        if (r.code === 0) {
          props.handleChangeMask(props.item, mask);
        } else {
          showToast(r.err || Str_DelFail);
        }
        // updateMask(mask);
      });
    }, 300);
  }

  // 发送后5分钟内撤回的文本消息可重新编辑
  function showReEdit(item: ChartMessageItem) {
    if (
      item.sender === getUid() &&
      item.type === MessageType.TEXT &&
      item.mask === MessageMaskType.RECALL &&
      props.item.stime &&
      Date.now() - props.item.stime <= 60 * 5 * 1000
    )
      return (
        <TouchableOpacity
          onPress={() => {
            props.handleRecall(props.item.content);
          }}
        >
          <Text style={{ fontSize: 12, color: color_main }}>{Str_ReEdit}</Text>
        </TouchableOpacity>
      );
    return <></>;
  }

  function handleUserHeadPress() {
    if (
      isGroupTopic(props.item.tid) &&
      props.group?.group_allow_member_visit !== "1" &&
      !props.isAdmin
    ) {
      return;
    }
    if (props.item.user) {
      const user = props.item.user;
      user && navigation.navigate("ContactInfoModeal", { current: user });
    }
  }

  function handleUserHeadLongPress() {
    if (props.item.user) {
      const user = props.item.user as any as User;
      user && props.onLongPressUserHead && props.onLongPressUserHead(user);
    }
  }

  function handleReadNumsClick() {
    if (props.item.send_statue === "1") {
    }
  }

  const handleClick = () => {
    if (
      props.talkSelectStatus === false &&
      props.item.type === MessageType.VOICE
    ) {
      // voiceRef?.current?.play(
      //   // PlayerManager.isReceiver ? "Receiver" : "Speaker"
      // );
    } else {
      props.onClick?.(props.item);
    }
  };

  const handleContextMenu = (event: GestureResponderEvent) => {
    event.preventDefault?.();
    event.stopPropagation?.();

    if (showPopover) {
      setShowPopover(false);
      return;
    }

    if (props.item.send_statue !== "0") {

      const { pageX, pageY } = event.nativeEvent;

      setPopoverPosition({
        x: pageX,
        y: pageY,
      });

      setShowPopover(true);
    }
  };

  const handleLongPress = (event: GestureResponderEvent) => {
    if (props.item.send_statue !== "0") {

      const { pageX, pageY } = event.nativeEvent;

      setPopoverPosition({
        x: pageX,
        y: pageY,
      });

      setShowPopover(true);
    }
  };

  if (props.item.visible === MessageAuditStatus.GONE) {
    return <></>;
  }
  if (props.item.type === MessageType.SYSTEM) {
    return (
      <View style={chatViewStyles.systemRender}>
        <Text
          // numberOfLines={1}
          // ellipsizeMode="tail"
          textBreakStrategy={"simple"}
          style={chatViewStyles.systemRenderText}
        >
          {systemTip}
        </Text>
      </View>
    );
  }
  //敏感词
  if (
    props.item.type === MessageType.TEXT &&
    props.item.visible === MessageAuditStatus.INFO
  ) {
    if (props.item.sender === ImSdk.getInstance().CurrentUid()) {
      return (
        <View style={chatViewStyles.systemRender}>
          <Text
            textBreakStrategy={"simple"}
            style={chatViewStyles.systemRenderText}
          >
            {props.item.auditWordTip}
          </Text>
        </View>
      );
    } else {
      return <></>;
    }
  }

  if (props.item.type === MessageType.LOCAL_TIME) {
    return (
      <View style={chatViewStyles.systemRender}>
        <View style={chatViewStyles.systemRenderWrap}>
          <Text style={chatViewStyles.systemRenderText}>
            {props.item.content}
          </Text>
        </View>
      </View>
    );
  }

  // 撤回消息
  if (props.item.mask === MessageMaskType.RECALL) {
    let text = "";
    const user = props.item.user;
    if (user) {
      text =
        user.uid === getUid()
          ? `${Str_You} ${Str_WithdrawAMsg}`
          : `${getDisplayName(user)} ${Str_WithdrawAMsg}`;
    }
    return (
      <View style={chatViewStyles.systemRender}>
        <View
          style={[
            chatViewStyles.systemRenderWrap,
            { flexDirection: "row", alignItems: "center" },
          ]}
        >
          <Text style={chatViewStyles.systemRenderText}>{text}</Text>
          {showReEdit(props.item)}
        </View>
      </View>
    );
  }

  if (props.item.mask) {
    return <></>;
  }

  const urls = extractUrls(props.item.content ?? "");

  return (
    <View ref={chatItemRef} style={[chatViewStyles.msgItem, flexStyle]}>
      <Pressable
        style={[chatViewStyles.avatarContent]}
        onPress={handleUserHeadPress}
        onLongPress={handleUserHeadLongPress}
      >
        <LeftView left={getAvatarByItem(props.item.user)} isRounded={true} />
      </Pressable>

      <View style={[chatViewStyles.msgContent]}>
        <View>
          {!isSelfSender && !isSignal && (
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginBottom: 4,
              }}
            >
              {props.item.user ? (
                <Text style={[chatViewStyles.msgUserName, nameStyle]}>
                  {getDisplayName(props.item.user)}
                </Text>
              ) : null}
              {tag > 0 && (
                <View
                  style={{
                    marginStart: 4,
                    marginEnd: 4,
                    backgroundColor:
                      tag === 1
                        ? "rgba(255,170,0,0.1)"
                        : tag === 2
                          ? "rgba(0,198,255,0.1)"
                          : "transparent",
                    borderRadius: 2,
                    paddingHorizontal: 2,
                  }}
                >
                  {(tag === 1 || tag === 2) && (
                    <Text
                      disabled={true}
                      style={{
                        color: tag === 1 ? "#ffaa00" : "#00c6ff",
                        textAlign: "center",
                        fontSize: 10,
                      }}
                    >
                      {tag === 1 ? Str_Group_owner : Str_Admin}
                    </Text>
                  )}
                </View>
              )}
            </View>
          )}

          <View
            style={[
              chatViewStyles.msgContentBox,
              {
                alignSelf: props.item.type === MessageType.DOCUMENT ? "stretch" : msgStyle.alignSelf,
                alignItems: isSelfSender ? "flex-end" : "flex-start",
                width: props.item.type === MessageType.DOCUMENT ? "100%" : undefined,
              },
            ]}
          >
            <View
              style={[
                chatViewStyles.msgContentRadius,
                {
                  borderRadius: 8,
                  backgroundColor:
                    isSelfSender && props.item.type === MessageType.IMAGE
                      ? white
                      : msgStyle.backgroundColor,
                  flexDirection: props.item.type === MessageType.DOCUMENT ? "column" : "row",
                  flexWrap: props.item.type === MessageType.DOCUMENT ? "nowrap" : "wrap",
                  alignItems: "flex-end",
                  alignSelf: props.item.type === MessageType.DOCUMENT ? "stretch" : undefined,
                  width: props.item.type === MessageType.DOCUMENT ? "100%" : undefined,
                  overflow: "hidden",
                  paddingVertical:
                    (props.item.type === MessageType.TEXT||props.item.type === MessageType.DOCUMENT) ? 10  : 0,
                },
              ]}
            >
              <ChatPopMenu
                setShowPopover={setShowPopover}
                showPopover={showPopover}
                popoverPosition={popoverPosition}
                onMenuClick={onMenuClick}
                message={props.item}
                translate={translate}
              >
                <Pressable
                  onPress={handleClick}
                  onLongPress={handleLongPress}
                >
                  <View
                    {...(Platform.OS === 'web' && {
                      onContextMenu: handleContextMenu,
                    })}
                    style={{
                      flexDirection:
                        (!urls[0]?.isUrl &&
                          props.item.content.length < 12 &&
                          props.item.type === MessageType.TEXT) ||
                          props.item.type === MessageType.VOICE ||
                          props.item.type === MessageType.RTC_VOICE ||
                          props.item.type === MessageType.RTC_VIDEO ||
                          (urls[0]?.isUrl && props.item.content.length < 20)
                          ? "row"
                          : "column",
                      alignItems:
                        (!urls[0]?.isUrl &&
                          props.item.content.length < 12 &&
                          props.item.type === MessageType.TEXT) ||
                          props.item.type === MessageType.VOICE ||
                          props.item.type === MessageType.RTC_VOICE ||
                          props.item.type === MessageType.RTC_VIDEO ||
                          (urls[0]?.isUrl && props.item.content.length < 20)
                          ? "center"
                          : "flex-end",
                    }}
                  >
                    <ContentRender
                      talkSelectStatus={props.talkSelectStatus}
                      voiceRef={voiceRef}
                      onLongPress={handleLongPress}
                      onClick={handleClick}
                      translate={translate}
                      isAdmin={props.isAdmin}
                      isBold={isBold === "1"}
                      adminColor={color}
                      adminUids={props.group?.adminUids}
                      item={props.item}
                      isSelf={isSelfSender}
                    />
                    {props.item.type === MessageType.IMAGE ||
                      props.item.type === MessageType.VIDEO ? (
                      <View
                        style={{
                          flexDirection: "row",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          paddingBottom: 2,
                          position: "absolute",
                          right: 6,
                          bottom: 0,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 12,
                            color: white,
                            backgroundColor: black30,
                            height: 18,
                            borderRadius: 9,
                            paddingHorizontal: 6,
                            paddingVertical: 2,
                            overflow: "hidden",
                            marginEnd: isSelfSender ? 2 : 0,
                            marginStart: isSelfSender ? 0 : 2,
                          }}
                        >
                          {timestampToTime(props.item.stime)}
                        </Text>
                        <Pressable>
                          <ReadCountStatus
                            msg={props.item}
                            uid={props.uid}
                            handleDel={props.handleDel}
                            submitMediaMsg={props.submitMediaMsg}
                            submitMsg={props.submitMsg}
                          />
                        </Pressable>
                      </View>
                    ) : (
                      <View
                        style={{
                          flexDirection: "row",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          alignSelf: "stretch",
                          paddingRight: 8,
                        }}
                      >
                        <Text
                          disabled={true}
                          style={{
                            fontSize: 12,
                            padding: 0,
                            color: isSelfSender ? white : "#a3a3a3",
                            marginEnd: isSelfSender ? 2 : 0,
                            marginStart: isSelfSender ? 0 : 2,
                            paddingRight: 2,
                          }}
                        >
                          {timestampToTime(props.item.stime)}
                        </Text>
                        {isSelfSender && (
                          <Pressable
                            style={{
                              justifyContent: "center",
                              alignItems: "center",
                              width: 22,
                              height: 15,
                            }}
                          >
                            <ReadCountStatus
                              msg={props.item}
                              uid={props.uid}
                              handleDel={props.handleDel}
                              submitMediaMsg={props.submitMediaMsg}
                              submitMsg={props.submitMsg}
                            />
                          </Pressable>
                        )}
                      </View>
                    )}
                  </View>
                </Pressable>
              </ChatPopMenu>
            </View>
          </View>

          {/* 先注释掉 QuoteContentRender 看看是不是这里的问题 */}
          {(props.item.meta?.quoteType ?? "") === MessageType.RTC_VOICE ||
            (props.item.meta?.quoteType ?? "") === MessageType.RTC_VIDEO ||
            props.item.meta?.quoteCnt ? (
            <View style={[msgStyle, chatViewStyles.quoteContentRadius]}>
              <QuoteContentRender
                maxLine={2}
                msg={{ ...props.item }}
                disabled={props.talkSelectStatus === true}
                handleQuoteLocal={props.handleQuoteLocal}
              />
            </View>
          ) : null}
        </View>
      </View>
    </View>
  );
};

export default ChatViewItemRender;

export const chatViewStyles = StyleSheet.create({
  time: {
    position: 'absolute',
    fontSize: 12,
    color: color_999999,
    right: 10,
    top: 2,
    zIndex: 10,
  },
  msgItem: {
    display: "flex",
    flex: 1,
    marginBottom: 24,
    paddingHorizontal: 12,
  },
  msgItemLeft: {
    flexDirection: "row",
  },
  msgItemRight: {
    flexDirection: "row-reverse",
  },
  msgContent: {
    position: "relative",
    flexShrink: 1,
    minWidth: 0,
    maxWidth: "70%",
    marginHorizontal: 8,
  },
  msgUserName: {
    fontSize: 12,
    color: color_999999,
  },
  userNameLeft: {
    textAlign: "left",
  },
  userNameRight: {
    textAlign: "right",
  },
  msgContentRadius: {
    maxWidth: "100%",
    minWidth: 0,
  },
  quoteContentRadius: {
    marginTop: 2,
    borderRadius: 4,
    fontSize: 12,
    overflow: "hidden",
    backgroundColor: ColorLine,
  },
  receivedContent: {
    backgroundColor: white,
    alignSelf: "flex-start",
  },
  sendedContent: {
    backgroundColor: "#65EFCF", // 保持绿色，但可以调整为更浅的绿色
    alignSelf: "flex-end",
  },
  quoteText: {
    paddingHorizontal: 12,
    paddingVertical: 4,
    color: color_666666,
  },
  receivedText: {
    color: color_333333,
    paddingHorizontal: 12,
    // paddingVertical: 10
  },
  sendedText: {
    color: "#000000",
    paddingHorizontal: 12,
    // paddingVertical: 10
    // paddingTop: 10
  },
  systemRender: {
    display: "flex",
    paddingHorizontal: 52,
    marginBottom: 10,
    marginTop: 10,
    alignSelf: "center",
  },
  //时间
  systemRenderWrap: {
    paddingVertical: 6,
    overflow: "hidden",
  },
  systemRenderText: {
    fontSize: 13,
    color: color_9F9E9E,
  },
  avatarContent: {
    position: "relative",
    width: 40,
    height: 40,
    flexShrink: 0,
  },
  msgContentBox: {
    position: "relative",
    display: "flex",
    maxWidth: "100%",
    minWidth: 0,
    overflow: "hidden",
  },
});
